import { Box, Text, Wrap } from '@chakra-ui/react';
import React, { useRef } from 'react';
import { useFormikContext } from 'formik';
import { localise, templateReplace } from '../../../services/lang/lang';
import MaxLengthInputControl from '../Form/MaxLengthInputControl';
import FormFieldErrors from '../FormFieldErrors/FormFieldErrors';
import { useTokens } from '../../../context/TokenProvider';
import AddPhotoButton from './AddPhotoButton';
import PhotoBox from './PhotoBox';
import { PhotoSize } from '../../../types/enums/PhotoSize';
import PhotoWrapper from './PhotoWrapper';
import { RenderIf } from '../RenderIf/RenderIf';
import { getLocalUrl } from '../../../services/photos/localImageUrlCache';
import MediaViewer from '../MediaViewer/MediaViewer';
const MAX_FILES = 5;
const Photos = ({ photos = [], canEdit, isShare, onPhotosMutated, }) => {
    const inputRef = useRef(null);
    const { isSubmitting, handleSubmit, errors, setFieldValue } = useFormikContext();
    const tokens = useTokens();
    const handleClick = () => {
        inputRef.current?.click();
    };
    const handleFilesChange = async (event) => {
        const selectedFiles = Array.from(event.target.files ?? []);
        if (!selectedFiles.length)
            return;
        await setFieldValue('media', selectedFiles[0]);
        handleSubmit();
    };
    const isButtonDisabled = isSubmitting || !canEdit || photos.length >= MAX_FILES;
    return (React.createElement(MediaViewer, { isShare: isShare, allMedia: photos }, ({ onMediaClick, onMediaKeyDown }) => (React.createElement(Box, { "data-testid": "photos_component", pb: tokens.Spacing06 },
        React.createElement(MaxLengthInputControl, { isInvalid: !!errors.media, maxLength: MAX_FILES, length: photos.length, label: "Photos" },
            React.createElement(Wrap, { spacingX: tokens.Spacing06, spacingY: tokens.Spacing06 },
                React.createElement(AddPhotoButton, { onClick: handleClick, isDisabled: isButtonDisabled }),
                photos?.map((photo) => {
                    const localUrl = getLocalUrl(photo.id);
                    const loadedPhoto = localUrl
                        ? {
                            url: localUrl,
                            id: photo.id,
                        }
                        : undefined;
                    return (React.createElement(PhotoBox, { cursor: "pointer", boxSize: 106, key: photo.id, onClick: () => onMediaClick(photo), onKeyDown: (e) => onMediaKeyDown(e, photo) },
                        React.createElement(PhotoWrapper, { isShare: isShare, photo: photo, loadedPhoto: loadedPhoto, onPhotoDeleted: onPhotosMutated, shouldLoad: true, canDelete: canEdit, size: PhotoSize.SMALL, borderRadius: tokens.BorderRadius02 })));
                })),
            React.createElement("input", { ref: inputRef, type: "file", "data-testid": "photos__input", hidden: true, accept: ".jpg,.jpeg", onChange: handleFilesChange }),
            React.createElement(RenderIf, { condition: canEdit },
                React.createElement(Text, { "data-testid": "photos_sub_text", mt: tokens.Spacing03, variant: "md-600-rg-4" }, templateReplace(localise('IMAGE_UPLOAD_RESTRICTION'), {
                    fileNum: MAX_FILES,
                }))),
            React.createElement(FormFieldErrors, { errors: errors.media }))))));
};
export default Photos;
